import { all } from 'redux-saga/effects';

import { sagas as loginSaga} from './Login';

import {sagas as searchResultSaga} from './SearchResult'

export default function* rootSaga() {
  yield all([
    loginSaga(),
    searchResultSaga()
  ]);

}
